export * from './src/fastgallery-item-v1-item-items.universal.js';
